<template>
  <div class="outerLayer">
    <div class="outerLayer_titleArea">
      <div class="left">
        <span>图片</span>
      </div>
      <div class="right">
        <!-- temporary ||  -->
        <!-- <el-button type="success" icon="el-icon-upload" @click="$refs.file.click()">上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures"></el-button> -->

        <el-upload
          ref="upload"
          class="upload-demo"
          action="#"
          :http-request="httpRequest"
          :multiple="true"
          :show-file-list="false"
          :limit="100"
        >
          <el-button
            size="small"
            type="primary"
            plain
          >点击上传</el-button>
        </el-upload>
      </div>
    </div>
    <!-- <div class="outerLayer_groupingArea">
      <div class="left">
        <span class="left_title">是否公用</span>
        <ul class="left_ul">
          <li class="ul_li" :class="{active:pageIfon.is_public == 1}" @click="lewrurl(1)">否</li>
          <li class="ul_li" :class="{active:pageIfon.is_public == 2}" @click="lewrurl(2)">是</li>
        </ul>
      </div> -->
    <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
    <!-- </div> -->
    <!-- <div class="outerLayer_groupingArea">
      <div class="left">
        <span class="left_title">图片类型</span>
        <ul class="left_ul">
          <li
            v-for="itemr,index in typelist"
            :key="index"
            :class="{active:pageIfon.business_type == itemr.type}"
            class="ul_li"
            @click="wrw(itemr.type)"
          >{{ itemr.name }}</li>
        </ul>
      </div> -->
    <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
    <!-- </div> -->
    <div class="outerLayer_mainArea">
      <div
        v-if="select.length"
        class="mainArea_deleteArea"
      >
        <div class="box">
          <span
            class="deleteArea_choice"
            :class="{
              have:select.length > 0,
              whole:isWhole
            }"
            @click="whole"
          />
          <span>已选择{{ select.length }}项内容</span>
          <span
            class="deleteArea_cancel"
            @click="select = []"
          >取消选择</span>
        </div>
        <span
          class="delete"
          @click="delimg(select)"
        >删除</span>
      </div>

      <div
        v-loading="loading"
        class="mainArea_main"
      >
        <ul class="main_ul">
          <li
            v-if="temporary"
            class="temporary"
          >
            <img
              v-if="temporary !== '多张'"
              class="li_img"
              :src="temporary"
            >
            <span
              v-else
              style="position: absolute;left: 50%;transform: translateX(-50%);font-size: 20px;font-weight: bold;"
            >多张</span>
            <span
              ref="men"
              class="men"
            />
          </li>

          <li
            v-for="item in datas"
            :key="item.id"
            class="ul_li"
            :class="{active:select.includes(item.id)}"
            @click="addDta(item)"
          >
            <img
              class="li_img"
              :src="item.path"
            >
            <span class="li_span">
              <i
                v-if="select.includes(item.id)"
                class="el-icon-check"
                style="color: #fff;"
              />
            </span>
          </li>

          <span v-if="datas && datas.length === 0">暂无数据</span>
        </ul>
      </div>

      <PaginationRight
        style="position: absolute;bottom: 0px;right: 0px;"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { storeBatch, getMaterialLibraryList, storeBatchdelete } from '@/api/miniProgramPhotoGallery'
import { materialroadtype } from '@/api/sourceMaterial.js'
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import getNowDate from '@/utils/mixins/convertToHump.js'
import { uploadFilesimg } from '@/utils/ObjectStorage.js'
import { getQcConfig } from '@/api/sourceminiprogram.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [getNowDate],
  data() {
    return {
      datas: [], // 列表数据
      pageIfon: {
        page: 1,
        page_size: 50,
        is_public: 1,
        business_type: 0
      },
      temporary: null,
      select: [],
      token: null,
      total: null,
      loading: false,
      typelist: [],
      tabPosition: 'bottom',
      config: {}
    }
  },
  computed: {
    isWhole() {
      const newArr = this.datas.filter(item => this.select.includes(item.id))
      return newArr.length === this.datas.length
    }
  },
  created() {
    // this.getQiniuToken()
    this.getlist()
    this.mawlist()
    this.getconfig()
    window.aa = this
  },
  methods: {
    delimg(ids) {
      console.log(11, ids)
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(async () => {
          await storeBatchdelete({
            ids
          })
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.select = []
          // this.mawlist()
          this.getlist()
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })

      // console.log(this.datas)
      // const filteredData = this.datas.filter(data => imglist.includes(data.id))
      // console.log(filteredData)
    },
    // 获取素材库类型列表
    async mawlist() {
      const data = await materialroadtype()
      this.typelist = data.data
      console.log('类型data', data)
    },
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },

    async getlist() {
      this.loading = true
      const data = await getMaterialLibraryList(this.pageIfon)
      this.loading = false
      this.datas = data.data.list
      this.total = data.data.total
    },

    async uploadPictures(e) {
      console.log(this.getNowDate())
      const arr = []
      for (let i = 0; i < e.target.files.length; i++) {
        const fileIfon = e.target.files[i]
        const img = new Image()
        const temporary = e.target.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        temporary !== '多张' && (img.src = temporary)
        this.temporary = temporary
        const options = {
          quality: 0.62,
          noCompressIfLarger: false,
          maxWidth: 1000,
          maxHeight: 1000
        }
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('ftype', ftype)
        if (ftype !== '.gif') {
          qiniu.compressImage(fileIfon, options).then(data => {
            const observable = qiniu.upload(
              data.dist,
              `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
              this.token,
              {
                fname: fileIfon.name // 文件名
              },
              {
                useCdnDomain: true // cdn域名加速
              }
            )
            observable.subscribe({
              next() {},
              error(err) {
                console.log(err)
              },
              complete: data => {
                arr.push({
                  type: 1,
                  height: img.height,
                  width: img.width,
                  size: fileIfon.size,
                  key: data.key
                })
                if (arr.length === e.target.files.length) {
                  this.$refs.men.style.height = 0
                  setTimeout(async () => {
                    await storeBatch({ list: arr, business_type: this.pageIfon.business_type, is_public: this.pageIfon.is_public })
                    await this.getlist()
                    this.temporary = null
                  }, 500)
                  // console.log(arr)
                }
              }
            })
          })
        } else {
          const observable = qiniu.upload(
            fileIfon,
            `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
            this.token,
            {
              fname: fileIfon.name // 文件名
            },
            {
              useCdnDomain: true // cdn域名加速
            }
          )
          observable.subscribe({
            next() {},
            error(err) {
              console.log(err)
            },
            complete: data => {
              arr.push({
                type: 1,
                height: img.height,
                width: img.width,
                size: fileIfon.size,
                key: data.key
              })
              if (arr.length === e.target.files.length) {
                this.$refs.men.style.height = 0
                setTimeout(async () => {
                  await storeBatch({ list: arr, business_type: this.pageIfon.business_type, is_public: this.pageIfon.is_public })
                  await this.getlist()
                  this.temporary = null
                }, 500)
                // console.log(arr)
              }
            }
          })
        }

        // const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
      }
    },

    addDta(item) {
      if (this.select.includes(item.id)) {
        const index = this.select.indexOf(item.id)
        this.select.splice(index, 1)
      } else {
        this.select.push(item.id)
      }
    },

    whole() {
      const newArr = this.datas.filter(item => this.select.includes(item.id))
      if (newArr.length === this.datas.length) {
        this.datas.forEach(item => {
          const index = this.select.indexOf(item.id)
          this.select.splice(index, 1)
        })
      } else {
        this.datas.forEach(item => {
          this.select.includes(item.id) || this.select.push(item.id)
        })
      }
    },

    fetchPageSize(num) {
      this.pageIfon.pageSize = num
      this.getlist()
    },
    fetchCurrentPage(num) {
      this.pageIfon.page = num
      this.getlist()
    },
    lewrurl(id) {
      this.pageIfon.page = 1
      this.pageIfon.is_public = id
      this.getlist()
    },
    wrw(id) {
      this.pageIfon.page = 1
      this.pageIfon.business_type = id
      this.getlist()
    },
    async getconfig() {
      const res = await getQcConfig()
      this.config = res.data
    },
    async httpRequest(e) {
      // console.log('e:', e)
      const _this = this
      const fileIfon = e.file
      console.log('fileIfon:', fileIfon)
      const arr = []
      const img = new Image()
      // const videoWidth = 0
      // const videoHeight = 0
      const fileType = fileIfon.type
      console.log('fileType:', fileType)

      if (fileType.startsWith('image/')) {
        // const temporary = e.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        // temporary !== '多张' && (img.src = temporary)
        // this.temporary = temporary
        const programimg = window.URL.createObjectURL(fileIfon)
        img.src = programimg
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        console.log('fileIfon.size:', fileIfon.size)
        const maxSize = 20 * 1024 * 1024 // 设置最大文件大小为50MB
        if (fileIfon.size > maxSize) {
          return this.$message('上传图片太大')
        }
        _this.showProgress = true
        this.percentage = 0
        console.log('fileIfon:', fileIfon)
        await uploadFilesimg(
          fileIfon,
          (num, id) => {
            this.percentage = num
          },
          'operation',
          this.config
        )
          .then(res => {
            // console.log('res-------:', res.files[0].options, this.config.domain)
            // this.updataimg = this.config.domain + res.files[0].options.Key
            // this.cover = res.files[0].options.Key
            arr.push({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: res.files[0].options.Key
            })
            setTimeout(async () => {
              await storeBatch({ list: arr, business_type: this.pageIfon.business_type, is_public: this.pageIfon.is_public })
              await this.getlist()
              this.temporary = null
            }, 500)
            // console.log(arr)
          })
          .catch(err => {
            console.log('err:-----', err)
          })
      } else {
        this.$message({
          message: '不支持的文件类型',
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  list-style-type: none;
  box-sizing: border-box;
}
.active {
  // color: skyblue;
  border: 1px solid #67c23a;
  color: #67c23a;
}
.outerLayer {
  width: 99%;
  min-height: calc(100vh - 248px);
  background-color: #fff;
  padding: 15px;
  border-radius: 7px;
  box-shadow: 0px 0px 5px #ccc;
  margin: 0 auto;
  margin-top: 2px;
  margin-bottom: 2px;
  .outerLayer_titleArea {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .outerLayer_groupingArea {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .left_title {
        font-size: 14px;
      }
      .left_ul {
        display: flex;
        align-items: center;
        .ul_li {
          list-style-type: none;
          // padding: 6px 10px;
          padding: 7px 10px 5px 10px;
          font-size: 13px;
          cursor: pointer;
          border-radius: 6px;
          &:not(.active):hover {
            background-color: rgb(230, 230, 230);
          }
          .active {
            background-color: rgb(202, 202, 202);
          }
        }
      }
    }
    .right {
      .right_span {
        font-size: 12px;
        padding: 6px 10px;
        border-radius: 5px;
        display: inline-block;
        cursor: pointer;
        &:hover {
          background-color: rgb(230, 230, 230);
        }
      }
    }
  }

  .outerLayer_mainArea {
    display: flex;
    align-items: center;
    font-size: 13px;
    justify-content: space-between;
    flex-direction: column;

    .box {
      display: flex;
      align-items: center;
    }

    .mainArea_deleteArea {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 13px 15px;
      background-color: rgb(231, 226, 226);
      .deleteArea_cancel {
        display: inline-block;
        margin-left: 15px;
        cursor: pointer;
      }

      .delete {
        cursor: pointer;
      }

      .deleteArea_choice {
        display: flex;
        width: 13px;
        height: 13px;
        box-shadow: 0px 0px 1px rgb(63, 63, 63);
        margin-right: 10px;
        cursor: pointer;
        position: relative;

        &.have {
          &::after {
            position: absolute;
            content: '';
            width: 50%;
            height: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: rgb(78, 211, 17);
          }
        }
        &.whole {
          &::after {
            position: absolute;
            content: '';
            width: 100%;
            height: 100%;
            background-color: rgb(78, 211, 17);
          }
        }

        &:hover {
          box-shadow: 0px 0px 2px black;
        }
      }
    }

    .mainArea_main {
      position: relative;
      width: 100%;
      .main_ul {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 0px;
        padding: 0px;

        .ul_li {
          width: 150px;
          height: 150px;
          position: relative;
          cursor: pointer;
          margin: 10px;
          display: flex;
          align-items: center;
          box-shadow: 0px 0px 1px black;

          &.active {
            &::after {
              position: absolute;
              content: '';
              width: 106%;
              height: 106%;
              background-color: rgb(112 188 138 / 30%);
              z-index: 11;
              top: -4px;
              left: -4px;
            }

            .li_span {
              display: flex;
            }
          }

          &:not(.active):hover {
            &::after {
              position: absolute;
              content: '';
              width: 106%;
              height: 106%;
              background-color: rgb(112 188 138 / 30%);
              z-index: 11;
              top: -4px;
              left: -4px;
            }

            .li_span {
              display: flex;
            }
          }

          .li_img {
            width: 100%;
            height: 100%;
          }
          .li_span {
            width: 15px;
            height: 15px;
            display: none;
            position: absolute;
            border: 1px solid black;
            top: 7px;
            left: 7px;
            z-index: 1111111;
            align-items: center;
            justify-content: center;
            background-color: rgb(11, 201, 43);
          }
        }
      }
    }

    .temporary {
      width: 150px;
      height: 150px;
      position: relative;
      margin: 10px;
      box-shadow: 0px 0px 1px #1f1f1f;
      display: flex;
      align-items: center;
      .men {
        position: absolute;
        width: 106%;
        height: 106%;
        background-color: rgba(150, 146, 146, 0.3);
        top: -4px;
        left: -4px;
        transition: all 1s;
        display: inline-block;
      }
      .li_img {
        width: 100%;
        /* height: 100%; */
      }
    }
  }
}
</style>
